// home.js
import React from 'react';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList'
import CustomListContainer from '../Util/List/CustomList/CustomListContainer'
import { useSelector } from 'react-redux';

import '../home/Home.css';

const Report = (props) => {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const pathsReport = {
    endpoint: config.endpoints.backend + 'portal/getallreport'
  }
  const listReport = {
    labelTitle: 'Parecer',
    icon: 'fa-newspaper',
    filter: {
      friendly_url
    },
    canDownload: true,
    fieldToDownload: 'file',
    columns: [
      {
        name: 'demonstrative_type',
        label: 'Tipo de Demonstrativo'
      },
      {
        name: 'publish_date',
        label: 'Data Base'
      },
      {
        name: 'obs',
        label: 'Descrição'
      }
    ]
  };

  return (
    <CustomListContainer
      canAdd={false}
      labelTitle={listReport.labelTitle}
      icon={listReport.icon}
      content={<CustomList list={{ ...listReport, ...pathsReport }} />}
    />
  );
};

export default Report;
